export const health_policy_framework = [
  {
    id: 1,
    name: 'pocs-strategic-plan-2025-2030',
    summary: 'shortsummary/pocs-strategic-plan-2025-2030.html',
    link: 'pocs-strategic-plan-2025-2030.pdf',
    audio_en: 'audio/en/pocs-strategic-plan-2025-2030_en.mp3',
    audio_af: 'audio/af/pocs-strategic-plan-2025-2030_af.mp3',
    audio_xh: 'audio/xh/pocs-strategic-plan-2025-2030_xh.mp3'
  }
];